module.exports = __webpack_public_path__ + "static/media/vitPreview.268204d0.jpg";